import styled from 'styled-components';
import helpers, { HelperProps } from '../helpers';

const Spacing = styled.div<HelperProps & { inline?: boolean }>`
  ${helpers};
  ${props => (props.inline ? 'display: inline-block;' : '')};
`;

export default Spacing;
